import React from "react";
import { OrganizationManagement } from "@components/Organization";

export default function OrganizationIndex() {
  return <OrganizationManagement />;
}
